export default "__VITE_ASSET__BUTpaBQ1__"